<template>
    <div style="position: relative" id="threat-score-page-container">
        <div class="col-xs-3" style="height: 100%; padding:0" v-show="!this.loading && this.partnerList">
            <dashboard-item-menu
                ref="threatScorePageItemMenu"
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="partnerRiskScoreMenuList"
                @menuItemClicked="onPartnerSelect"
                :customerAvatar="partnersRisksItem.customer_logo"
                :threatScoreMenu="true"
            ></dashboard-item-menu>
        </div>
        <div class="col-xs-9" style="height: 100%; position: relative;" v-show="this.partnerList">
            <partner-risk-score-large
                v-show="!this.loading"
                :files='partnersRisksItem'
                :is_send_threat_email_disabled="is_send_threat_email_disabled()"
                @send_threat_email="sendThreatEmail"
            ></partner-risk-score-large>
        </div>
        <div class="partner-is-calculating-div" style="height: 100%; position:relative;"
             v-show="!this.partnerList && !this.loading">
            <img src="../assets/threat-calculating.png"/>
            <h4 style="color: white; width: 70%; padding-top: 24px" align="center">Your threat score will be calculated
                in a few minutes.
            </h4>
            <h4 style="color: white; width: 70%" align="center">In the mean time you may check other pages.</h4>
        </div>
        <loading-modal v-if="loading" :color="'blue'"></loading-modal>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import LoadingModal from "@/components/modals/LoadingModal";

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "#C9C9C9";
    const MENU_ITEM_BACKGROUND_COLOR = "#7F7F7F";
    const MENU_ITEM_COLOR = "rgb(63,92,111)";
    const MENU_TITLE_COLOR = "white";
    const RISK_SCORE_MENU_ITEM_COUNT = 6;

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';
    import PartnerRiskScoreLarge from "./../pages/dashboard-page/partner-risk-score/PartnerRiskScoreLarge";

    export default {
        name: "threat-score",
        components: {
            PartnerRiskScoreLarge,
            DashboardItemMenu: DashboardItemMenu,
            LoadingModal: LoadingModal
        },
        props: {},
        mixins: [Common],
        data() {
            return {
                mainTitle: 'THREAT SCORE\nBOARD',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                loading: false,
                partnerRiskScoreMenuList: [],
                partnerRiskScoreItem: {},
                overallPartnerRiskSelected: false,
                selectedPartnerItem: {},
                enLargeClicked: null,
                partnerRiskScoreProgressPercentage: [],
                partnerRiskScoreProgressColor: [],
                sortedCount: null,
                zeroArray: [],
                sortedArray: [],
                zeroCount: null,
                partnersRisksItem: {},
                partnersName: [],
                partnerList: [],
                partnerListProgressColor: [],
                pageName: 'Partner Threat Score Widget'
            }
        },
        methods: {
            is_send_threat_email_disabled() {
                let role_string = this.getStatus(this.getEnterpriseStatus);
                return !(role_string != 'Pending' && role_string != 'In Analysis' && role_string != 'Inactive');
            },
            sendThreatEmail(enterprise_id) {
                $("#threat-score-page-container #send-threat-email-partner-button-large").css("display", "none");
                $("#threat-score-page-container #send-threat-email-partner-indicator-large").css("display", "block");
                $("#threat-score-page-container #send-threat-email-partner-button").css("display", "none");
                $("#threat-score-page-container #send-threat-email-partner-indicator").css("display", "block");
                let log_start = Date.now();
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/send_risk_email';
                let body = {
                    "enterprise_id": enterprise_id
                };
                this.$http.post(path, body).then(response => {
                    this.saveLog(this, this.pageName, ' Threat Mail sent successfull.', this.getDurationInSeconds(log_start, Date.now()), null);
                    this.sendThreatEmailSuccessCallback(response.data);
                    $("#threat-score-page-container #send-threat-email-partner-button").css("display", "block");
                    $("#threat-score-page-container #send-threat-email-partner-indicator").css("display", "none");
                    $("#threat-score-page-container #send-threat-email-partner-button-large").css("display", "block");
                    $("#threat-score-page-container #send-threat-email-partner-indicator-large").css("display", "none");
                }, response => {
                    this.saveLog(this, this.pageName, ' Threat Mail sent error. ', this.getDurationInSeconds(log_start, Date.now()), null);
                    this.showErrorMessage("Couldn't send Threat Mail. Please contact with support.");
                    $("#threat-score-page-container #send-threat-email-partner-button").css("display", "block");
                    $("#threat-score-page-container #send-threat-email-partner-indicator").css("display", "none");
                    $("#threat-score-page-container #send-threat-email-partner-button-large").css("display", "block");
                    $("#threat-score-page-container #send-threat-email-partner-indicator-large").css("display", "none");
                });
            },
            sendThreatEmailSuccessCallback(data) {
                if (data.return_code === Constants.ReturnCodes.ArgumentError) {
                    this.showErrorMessage(data.error_message);
                } else if (data.return_code === Constants.ReturnCodes.Success) {
                    this.showSuccessMessage(data.data)
                }
            },
            onPartnerSelect(menuItem) {
                this.selectedPartnerItem = null;
                this.$nextTick(function () {
                    this.selectedPartnerItem = menuItem;
                    this.setPartnerRiskSource();
                });
                this.setSelectedPartnerRiskScoreItem(menuItem);
                this.setPartnerRiskWidgetSelectedPartnerId(menuItem.enterprise_id);
            },
            getPartnerRiskScoreList() {
                let log_start = Date.now();
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/partner_and_enterprise_risk_score';
                this.$http.post(path).then(response => {
                    this.partnerList = response.body.partner_risk_score_list;
                    if (!this.partnerList) {
                        this.loading = false;
                        return;
                    }
                    this.sortRiskMenuList();
                    this.partnerList.unshift(response.body.enterprise_risk_score);
                    this.selectedPartnerItem = this.getSelectedPartnerRiskScoreItem;
                    var items = [];
                    for (var i = 0; i < this.partnerList.length; i++) {
                        var item = {
                            id: this.uuidv4(),
                            enterprise_id: this.partnerList[i].enterprise_id,
                            enumNo: i,
                            text: this.partnerList[i].customer_name,
                            color: MENU_ITEM_COLOR,
                            progress: this.partnerList[i].overall_risk_percent,
                            progressColor: this.partnerListProgressColor[i],
                            selectedColor: "white",
                            selected: false
                        };
                        if (this.selectedPartnerItem != null) {
                            item.selected = this.selectedPartnerItem.text === item.text;

                            if (item.selected) {
                                this.$nextTick(function () {
                                    this.selectedPartnerItem = item;
                                });
                            }
                        } else {
                            item["selected"] = true;
                            this.selectedPartnerItem = item;
                            this.setSelectedPartnerRiskScoreItem(item);
                            this.setPartnerRiskWidgetSelectedPartnerId(item.enterprise_id);
                        }
                        items.push(item)
                    }

                    this.partnerRiskScoreMenuList = [
                        {
                            type: "selectableProgress",
                            text: "CHOOSE COMPANY BELOW",
                            color: MENU_TITLE_COLOR,
                            backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                            open: true,
                            items: items
                        }
                    ];
                    this.setPartnerRiskSource();
                    this.loading = false;
                }, response => {
                    
                });

            },
            getPartners() {
                this.loading = true;
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/partners/get', {verbose: true}).then(response => {
                    this.partnersName = response.data.data;
                    for (var i = 0; i < this.partnersName.length; i++) {
                        if (this.partnersName[i].customer_name != this.getSelectedPartnerRiskScoreItem) {
                            this.setSelectedPartnerRiskScoreItem(null);
                            this.setPartnerRiskWidgetSelectedPartnerId(null);
                        } else {
                            this.setSelectedPartnerRiskScoreItem(this.partnersName[i].customer_name);
                            this.setPartnerRiskWidgetSelectedPartnerId(this.partnersName[i].customer_id);
                        }
                    }
                }, response => {
                    this.loading = false;
                });

            },
            sortRiskMenuList() {
                this.partnerList.sort(function (a, b) {
                    return a.overall_risk_percent - b.overall_risk_percent;
                });
                this.partnerList.reverse();

                for (var i = 0; i < this.partnerList.length; i++) {
                    this.partnerListProgressColor[i] = "#" + this.partnerList[i].overall_risk_bg;
                }
            },
            setPartnerRiskSource() {
                if (this.partnerList) {
                    for (var i = 0; i < this.partnerList.length; i++) {
                        if (this.selectedPartnerItem.text === this.partnerList[i].customer_name) {
                            this.partnersRisksItem = this.partnerList[i];
                            break;
                        }
                    }
                    this.sortedPartnerSubItems(this.partnersRisksItem);
                }
            },
            sortedPartnerSubItems(files) {
                //Sort Risk Score Start...
                files.sub_risks.sort(function (a, b) {
                    return a.percentage - b.percentage;
                });
                files.sub_risks.reverse();
                for (var i = 0; i < files.sub_risks.length; i++) {
                    if (files.sub_risks[i].percentage !== 0) {
                        this.sortedArray[i] = files.sub_risks[i];
                        this.sortedCount++;
                    } else {
                        this.zeroArray[i] = files.sub_risks[i];
                        this.zeroCount++;
                    }
                }
                this.zeroArray.sort(function (a, b) {
                    return a.risk_group_enum_no - b.risk_group_enum_no;
                });
                for (var i = 0; i < this.zeroCount; i++) {
                    this.sortedArray[this.sortedCount + i] = this.zeroArray[i];
                }
                for (var i = 0; i < this.sortedArray.length; i++) {
                    this.sortedArray[i].risk_elements.sort(function (a, b) {
                        return a.percentage - b.percentage;
                    });
                    this.sortedArray[i].risk_elements.reverse();
                }
            },
            ...mapActions([
                "setSelectedPartnerRiskScoreItem",
                "setPartnerRiskWidgetSelectedPartnerId"
            ])
        },
        computed: {
            ...mapGetters([
                "getSelectedPartnerRiskScoreItem",
                "getPartnerRiskWidgetSelectedPartnerId",
                "getEnterpriseStatus"
            ])
        },
        mounted() {
        },
        beforeMount() {
            this.getPartners();
            this.getPartnerRiskScoreList();
        }
    }
</script>

<style scoped>
    h4 {
        font-family: Digital-Serial-Regular;
    }

    .partner-is-calculating-div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #threat-score-page-container {
        position: absolute;
        height: 95%;
        overflow: hidden;
        top: 0;
        background-color: black;
    }

    .col-xs-3 {
        width: 20%;
    }

    .col-xs-9 {
        width: 80%;
    }

    .dashboard_item_menu_title {
        font-size: 1.375em !important;
    }

    .partner-risk-score-large {
        height: 850px !important;
        overflow: scroll;
    }

    #threat-score-container {
        background: black;
        height: 95%;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .text-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .text {
        fill: white;
        font-family: Digital-Serial-Bold;
        font-size: 20px;
    }

    .small-text {
        fill: #416477;
        font-family: Digital-Serial-Bold;
        font-size: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/ThreatScore.vue